import { render, staticRenderFns } from "./LabelColorCustomization.vue?vue&type=template&id=cc2e84ec&scoped=true"
import script from "./LabelColorCustomization.vue?vue&type=script&lang=js"
export * from "./LabelColorCustomization.vue?vue&type=script&lang=js"
import style0 from "./LabelColorCustomization.vue?vue&type=style&index=0&id=cc2e84ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2e84ec",
  null
  
)

export default component.exports